import { useMemo } from 'react';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { type ActionCreatorsMapObject, bindActionCreators } from 'redux';

import { reduxActions } from './reduxActions';
import type { TReduxDispatch, TReduxState } from './types';

export const useReduxDispatch: () => TReduxDispatch = useDispatch;
export const useReduxSelector: TypedUseSelectorHook<TReduxState> = useSelector;

export function useBoundActions<M extends ActionCreatorsMapObject, N extends ActionCreatorsMapObject>(
  getActionCreators: (actions: typeof reduxActions) => M,
): N;

export function useBoundActions<A, M extends ActionCreatorsMapObject<A>>(
  getActionCreators: (actions: typeof reduxActions) => M,
): M;

export function useBoundActions<A, M extends ActionCreatorsMapObject<A>>(
  getActionCreators: (actions: typeof reduxActions) => M,
): M {
  const dispatch = useReduxDispatch();

  return useMemo(() => bindActionCreators(getActionCreators(reduxActions), dispatch), [dispatch, getActionCreators]);
}
